import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import bg1 from '../Assets/bg/bg5.jpg'; 
import bg2 from '../Assets/bg/Pilar.jpg';
import bg3 from '../Assets/bg/SanMiguel.jpg';
import bg4 from '../Assets/bg/Capayas.jpg';
import bg5 from '../Assets/bg/Ubay.jpg';
import LoginModal from './Login2';
import { useNavigate } from 'react-router-dom';
import useTypewriter from '../Hooks/HomeHooks/useTypewriter';

const HeroSection = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const images = [bg1, bg2, bg3, bg4, bg5];
  const locations = ['BENLIW DAM, UBAY', 'MALINAO ,PILAR', 'BAYONGAN SAN MIGUEL', 'CAPAYAS UBAY BOHOL', '  BENLIW'];

  const typedWord = useTypewriter(['DISA']);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const preloadImages = () => {
      images.forEach((image) => {
        const img = new window.Image();
        img.src = image;
      });
    };

    preloadImages();
  }, [images]);

  // If a user is already logged in, redirect them to their dashboard
  useEffect(() => {
    try {
      const token = localStorage.getItem('token');
      const role = localStorage.getItem('role');
      if (token && role) {
        switch (role) {
          case 'admin':
            navigate('/DashboardAdmin', { replace: true });
            break;
          case 'guest':
            navigate('/DashboardGuest', { replace: true });
            break;
          case 'noso':
            navigate('/DashboardNoso', { replace: true });
            break;
          case 'bohol':
            navigate('/DashboardBohol', { replace: true });
            break;
          case 'siquijor':
            navigate('/DashboardSiquijor', { replace: true });
            break;
          case 'cebu':
            navigate('/DashboardCebu', { replace: true });
            break;
          case 'nis':
            navigate('/DashboardNis', { replace: true });
            break;
          default:
            break;
        }
      }
    } catch (e) {
      // ignore
    }
  }, [navigate]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setBackgroundIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [images.length]);

  const handleDotClick = (index) => {
    setBackgroundIndex(index);
  };

  return (
    <Container bgImage={images[backgroundIndex]}>
      <Overlay />
      <CenterSection>
        <Content>
          <TopSection>
          <TitleBlock>
           <LineOne>Smart Irrigation </LineOne>
         <LineTwo>
           Begins with <HighlightedWord>{typedWord}</HighlightedWord>
        </LineTwo>
        </TitleBlock>
        </TopSection>
         
        <Subtitle>"Digital Irrigator System Asssessment"</Subtitle>
        </Content>

          <Layout>
            <Location>{locations[backgroundIndex]}</Location>
            <ImageGallery>
              <ImageWrapper>
                {/* Main Image (Center the image) */}
                <StyledImageContainer>
                  <StyledImage
                    src={images[backgroundIndex]}
                    alt={`bg${backgroundIndex + 1}`}
                    isMainImage={true} 
                  />
                </StyledImageContainer>
              </ImageWrapper>
            </ImageGallery>
          </Layout>

          <DotContainer>
            {images.map((_, index) => (
              <Dot key={index} onClick={() => handleDotClick(index)} active={backgroundIndex === index} />
            ))}
          </DotContainer>
       
      </CenterSection>
    
   
      <LoginModal isOpen={isModalOpen} toggleModal={toggleModal} />
    </Container>
  );
};

export default HeroSection;

const Container = styled.section`
  display: flex;
  height: 100vh;
  padding-top: 50px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  background-position: center;
  transition: background-image 1s ease-in-out;
  font-family: 'Poppins', 'Inter', 'Segoe UI', sans-serif;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(59, 57, 57, 0.5);
  z-index: 1;
`;

const CenterSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 2;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 2;
  width: 100%;
  padding: 1rem 1.5rem;
  color: white;
  text-align: left;
`;

const TopSection = styled.div`
  margin-bottom: 2rem;
  margin-top: 7rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    margin: 2rem auto;
  }
`;



const TitleBlock = styled.div`
  width: 100%;
  text-align: flex-start;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  transform: translateX(10%); 
`;

const LineOne = styled.h1`
  font-size: 3rem;
  font-weight: 400;
  color: #f0f0f0;
  margin-bottom: 0.3rem;

  @media (max-width: 868px) {
    font-size: 1.8rem;
  }
`;

const LineTwo = styled.h1`
  font-size: 3rem;
  font-weight: 400;
  color: #f0f0f0;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const HighlightedWord = styled.span`
  color: rgb(46, 250, 155);
  font-weight: 600;
`;



const Subtitle = styled.h2`
  font-size: 1rem;
  line-height: 1rem;
  padding: 1rem;
  border-radius: 15px;
  max-width: 90%;
  color: rgb(247, 241, 241);
 margin-top: 0rem;
  transform: translateX(7%); 
`;


const Layout = styled.div`
  display: flex;
  flex-direction: column; // or row for large screens
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;


const Location = styled.p`
  font-size: 1rem;
  font-weight: 700;
  position: absolute;
  top: 65%;
  left: 5%;
  transform: translateY(0%);
  white-space: nowrap;
  color: white;
  max-width: 60%;
  text-align: left;
  background: rgba(249, 250, 249, 0.3);
  padding: 1rem;
  border-radius: 8px;
`;

const ImageGallery = styled.div`
  position: relative;
  width: 100%;
  max-width: 80%;
  margin-top: -10%;
  margin-left: 50%;
  
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledImageContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 50%;
  max-width: 60%; 
  height: auto;
  margin: 0 auto; 
`;
;

const StyledImage = styled.img`
  width: 100%; 
  max-width: 100%; 
  height: auto; 
  max-height: 40vh; 
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border: 5px solid ${(props) => (props.isMainImage ? 'white' : 'transparent')};
  object-fit: cover; /* Ensures the image fills the container proportionally */


  @media (max-width: 700px) {
    max-height: 50vh; 
  }

  @media (max-width: 400px) {
    max-height: 40vh; 
  }
`;


const DotContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 2rem;
  margin-left: 50%;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${(props) => (props.active ? '#FFD700' : '#ddd')};
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #FFD700;
  }
`;

const BottomImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height:  130px;
  z-index: 1;
  object-fit: bottom;
  transform: translateY(70px);
  pointer-events: none; 
`;
  